<template>
  <div class="content-layout">
    <a-alert type="info" style="margin-bottom: 16px;">
      <template #description>
        <p>
          所有产品的固件ID范围做了初步的划分，维护者可以按划分的类型对应添加：
        </p>
        <p>
          <span>zigbee子设备，范围 0x0001 - 0xAFFF</span><br>
          <span> CIT对讲设备，范围0xD001 - 0xDFFF</span><br>
          <span>LORA子设备，范围0xE400 - 0xE7FF</span><br>
          <span>网络子设备，范围0xE800 - 0xEBFF</span><br>
          <span>其他待分配子设备，范围0xEC00 - 0xEFFF</span><br>
          <span>中控/ACAP，范围 0xFF00 - 0xFF4F</span><br>
          <span>智慧屏中控，范围 0xFF50 - 0xFF7F</span><br>
          <span>FAKE-CPU 平台研发专用，0xFFFF</span><br>
        </p>
      </template>
    </a-alert>
    <div class="holidays-operations">
      <a-form layout="inline">
        <a-form-item style="margin: 0">
          <a-select v-if="filterSelected" v-model="filterSelected" style="width: 130px">
            <a-icon slot="suffixIcon" type="down"></a-icon>
            <a-select-option v-for="filter in filterOptions" :key="filter.value" :value="filter.value">
              {{ filter.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-input
            v-model="searchKeyword"
            class="search-keyword"
            placeholder="请输入"
            allowClear
            @keyup.enter.native="doSearch"
          ></a-input>
        </a-form-item>
        <a-form-item>
          <a-button class="btn" type="primary" @click="handleSearch">搜索</a-button>
          <a-button class="btn" type="primary" @click="handleAdd" v-if="$hasPermissions(['rcs:firmware_type:create'])"
            >添加</a-button
          >
          <a-button class="btn" type="primary" @click="handleSync" v-if="$hasPermissions(['rcs:firmware_type:sync'])"
            >同步</a-button
          ></a-form-item
        >
      </a-form>
    </div>
    <a-table
      size="middle"
      :pagination="false"
      :dataSource="tableData"
      :columns="this.$constRepository.firmwareType.columns"
      class="firmware-type"
      @change="tableChange"
      rowKey="id"
    >
      <template slot="modelIdentifiers" slot-scope="scope">
        <span>{{ scope.join(',') }}</span>
      </template>
      <template slot="lastModificationTime" slot-scope="scope">{{ scope | parseTime | orNA }}</template>
      <template slot="createTime" slot-scope="scope">{{ scope | parseTime | orNA }}</template>

      <template slot="action" slot-scope="scope">
        <a-button
          v-if="$hasPermissions(['rcs:firmware_type:update'])"
          class="green-btn"
          ghost
          @click="handleEdit(scope)"
          >编辑</a-button
        >
        <a-divider type="vertical" />
        <a-popconfirm okText="是" cancelText="否" title="是否固件类型?" @confirm="handleDelete(scope)">
          <a-button v-if="$hasPermissions(['rcs:firmware_type:delete'])" class="red-btn" ghost type="danger"
            >删除</a-button
          >
        </a-popconfirm>
      </template>
    </a-table>
    <div class="pagination">
      <a-pagination
        :current="pageInfo.page"
        :show-total="(total) => `共 ${pageInfo.totalElements} 条`"
        show-quick-jumper
        show-size-changer
        :total="pageInfo.totalElements"
        @showSizeChange="onShowSizeChange"
        @change="onChange"
        :pageSizeOptions="['10', '20', '30', '40']"
      />
      <br />
    </div>
    <FirmwareTypeModal ref="firmwareTypeModal"></FirmwareTypeModal>
  </div>
</template>
<script>
import { Modal } from 'ant-design-vue';
import FirmwareTypeModal from './comonents/FirmwareTypeModal';

export default {
  name: 'FirmwareManagement',
  components: { FirmwareTypeModal },
  mounted() {
    this.listFirmwareTypes();
  },
  data() {
    return {
      filterSelected: this.$constRepository.firmwareType.FILTER_OPTION_IMAGE_TYPE_ID.value,
      filterOptions: this.$constRepository.firmwareType.FILTER_OPTIONS,
      requestParams: {},
      searchKeyword: '',
      tableData: [],
      pageInfo: {
        page: 1,
        size: 10,
        totalElements: 0,
        totalPages: 0,
      },
    };
  },
  methods: {
    processSearchKeyword() {
      this.$set(this.requestParams, 'imageTypeId', undefined);
      this.$set(this.requestParams, 'modelIdentifier', undefined);
      this.$set(this.requestParams, 'imageTypeHex', undefined);
      switch (this.filterSelected) {
        case this.$constRepository.firmwareType.FILTER_OPTION_IMAGE_TYPE_ID.value:
          this.$set(this.requestParams, 'imageTypeId', this.searchKeyword);
          break;
        case this.$constRepository.firmwareType.FILTER_OPTION_MODEL.value:
          this.$set(this.requestParams, 'modelIdentifier', this.searchKeyword);
          break;
        case this.$constRepository.firmwareType.FILTER_OPTION_HEX.value:
          this.$set(this.requestParams, 'imageTypeHex', this.searchKeyword);
          break;
        default:
          break;
      }
    },
    tableChange() {
      // eslint-disable-next-line radix
      this.loadedPageData();
    },
    handleSearch() {
      this.pageInfo.page = 1;
      this.loadedPageData();
    },
    // 打开编辑弹窗
    handleEdit(params) {
      this.$refs.firmwareTypeModal.showModal(params);
    },
    handleAdd() {
      this.$refs.firmwareTypeModal.showModal({});
    },
    handleSync() {
      Modal.confirm({
        title: () => '提示',
        content: () => '同步操作会对相同固件类型ID的数据进行覆盖，是否继续？',
        onOk: () => {
          // 进入当前关联编辑状态
          this.syncData();
        },
      });
    },
    syncData() {
      this.$apiManager.firmwareType
        .sync()
        .then(() => {
          this.$message.success('同步成功');
          this.loadedPageData();
        })
        .catch(() => {
          this.$message.error('同步失败');
        });
    },
    // 确认删除事件
    handleDelete(params) {
      this.$apiManager.firmwareType
        .delete(params.id)
        .then(() => {
          this.$message.success('删除成功');
          this.loadedPageData();
        })
        .finally(() => {});
    },
    // 初始化按钮事件
    init() {
      this.loadedPageData();
    },
    onShowSizeChange(current, pageSize) {
      this.pageInfo.page = 1;
      this.$set(this.pageInfo, 'size', pageSize);
      this.loadedPageData();
    },
    onChange(pageNumber) {
      this.$set(this.pageInfo, 'page', pageNumber);
      this.loadedPageData();
    },
    async listFirmwareTypes() {
      const params = {
        ...this.requestParams,
        page: this.pageInfo.page - 1,
        size: this.pageInfo.size,
      };
      const response = await this.$apiManager.firmwareType.getList(params);
      this.tableData = response.data.elements;
      this.$set(this.pageInfo, 'totalElements', response.data.totalElements);
      this.$set(this.pageInfo, 'totalPages', response.data.totalPages);
      this.$set(this.pageInfo, 'currentPage', response.data.currentPage);
    },
    async loadedPageData() {
      this.processSearchKeyword();
      await this.listFirmwareTypes();
      if (this.pageInfo.currentPage + 1 > this.pageInfo.totalPages && this.pageInfo.currentPage) {
        this.pageInfo.page = 1;
        await this.listFirmwareTypes();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content-layout {
  height: auto;

  .holidays-operations {
    display: flex;
    justify-content: space-between;
    // margin: 10px 10px;

    .btn {
      margin-left: 15px;
      width: 80px;
    }

    .right {
      display: flex;
    }
  }

  .firmware-type {
    margin-top: 1%;

    .green-btn {
      color: green;
      border: none;
    }

    .red-btn {
      color: red;
      border: none;
    }
  }

  .pagination {
    margin-top: 3%;
  }
}
</style>
